module.exports = __webpack_public_path__ + "static/media/service.e2202450.png";